import { useNavigate } from 'react-router-dom';
import { GiveKudosModal } from '../components/respect/GiveKudosModal';

/**
 * Sidebar shortcut page (Option C — Phase 61 follow-up).
 *
 * The Plan 05 acceptance flow originally assumed `/profile/:userId` peer
 * profiles where the give-kudos button would mount the modal. That route
 * was never wired (only `/profile` for the current user exists), so peers
 * had no way to send kudos at all. This page is the workaround: a dedicated
 * `/give-kudos` route that opens the modal in directory-picker mode
 * (`recipientUserId` omitted), then navigates back to `/dashboard` on
 * close / success.
 */
export function GiveKudosPage() {
  const navigate = useNavigate();
  const close = () => navigate('/dashboard');
  return <GiveKudosModal onClose={close} onSuccess={close} />;
}
